import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import Modal from '@components/Shared/Modal/Modal';
import AreaHeader from '@components/Shared/AreaHeader/AreaHeader';
import SubHeader from '@components/ContactUs/SubHeader';
import BasicText from '@components/ContactUs/BasicText';
import Forms from '@components/ContactUs/Forms';

import { ContactUsStyles } from './ContactUs.styled';

const ContactUs = () => {
  const [helpModalVisible, setHelpModalVisible] = useState(false);

  useEffect(() => {
    if (helpModalVisible) {
      const elem = document.getElementById('okay');
      if (elem) {
        elem.focus();
      }
    }
  }, [helpModalVisible]);

  const onKeyDownOkay = (ev) => {
    // enter
    if (ev.keyCode === 13) {
      setHelpModalVisible(false);
    }
    ev.preventDefault();
  };

  return (
    <ContactUsStyles>
      <Head htmlAttributes={{ lang: 'en' }}>
        <title>Contact Us | Clayton Homes</title>
        <meta
          name="description"
          content="Have your home questions answered. Request more information about your current or future Clayton home, or submit for general inquiries."
        />
      </Head>

      <AreaHeader headerText="Contact Us" />

      {helpModalVisible && (
        <div className="help-container">
          <Modal onClose={() => setHelpModalVisible(false)}>
            <div className="help-modal">
              <h4>Finding your home&rsquo;s serial&nbsp;number</h4>
              <p>
                Your home&rsquo;s serial number can be found on the home&rsquo;s
                data plate which is located under the kitchen sink on the
                cabinet door or in the primary bedroom closet. The serial number
                should look similar to: ABC123456ABAB. You can also find the
                serial number on your paperwork from when you purchased your
                home.
              </p>
              <p>
                The data plate is a laminated sheet of paper with information
                about your home including the wind zone to which it was built
                and the home building facility that built your home.
              </p>
              <a
                id="okay"
                href="#"
                tabIndex="0"
                onClick={(ev) => {
                  setHelpModalVisible(false);
                  ev.preventDefault();
                }}
                onKeyDown={onKeyDownOkay}
              >
                OKAY
              </a>
            </div>
          </Modal>
        </div>
      )}

      <div className="subheader-container">
        <SubHeader />
      </div>
      <div className="body-content">
        <Forms onToggleHelpModal={() => setHelpModalVisible(true)} />
        <BasicText />
      </div>
    </ContactUsStyles>
  );
};

export default ContactUs;
